/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/meshes/GenericPackaging_2v1.glb -o src/meshes/GenericPackaging_2v1.tsx -r public -t -k -s -p 7 
Modified by: Aeroplane GLTFJSX Generator v1.9.1
*/

import { Group, Mesh, MeshStandardMaterial } from "three";
import { forwardRef, ForwardedRef, useEffect, useImperativeHandle, ForwardRefExoticComponent, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import useM_StyroFoam from "@materials/M_StyroFoam";
import { GLTFJSXUtils } from "@utils/GLTFJSXUtils";
import { GLTF } from "three-stdlib";
import { ObjectUtils } from "@utils/ObjectUtils";
import { assetPath } from "@utils/Config";

const mesh = assetPath("/meshes/GenericPackaging_2v1.glb");

type GLTFResult = GLTF & {
    nodes: {
        ["EPS-Solution"]: Mesh;
    }
    materials: {
        M_StyroFoam: MeshStandardMaterial;
    }
}

export type Handle = {
    root: Group | null;
    meshes: GLTFResult["nodes"];
};
export function useHandle(ref: ForwardedRef<Group>) {
    const handle = useRef<Handle>(null);
    useEffect(() => {
        if (!ref) return;
        if (typeof ref === "function") ref(handle.current?.root ?? null);
        else ref.current = handle.current?.root ?? null;
    }, [handle, ref]);
    return handle;
};
export default forwardRef<Handle, JSX.IntrinsicElements["group"]>(function Model(props, ref) {
    const group = useRef<Group>(null);
    const { nodes, materials } = useGLTF(mesh) as GLTFResult;
    const M_StyroFoam = useM_StyroFoam();
    useImperativeHandle(ref, () => GLTFJSXUtils.createHandle<Handle>({ root: group.current }, nodes), [group, nodes]);
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh name="EPS-Solution" receiveShadow={props.receiveShadow} castShadow={props.castShadow} {...ObjectUtils.pick(nodes["EPS-Solution"], "geometry", "morphTargetDictionary", "morphTargetInfluences")} material={M_StyroFoam} raycast={props.raycast} renderOrder={props.renderOrder} />
        </group>
    );
});

useGLTF.preload(mesh, true, true);
